import { createFileRoute, redirect } from '@tanstack/react-router';

// /admin lands on the first sidebar item (Members). The hub card-grid is
// gone — admin now mirrors group-scoped admin (/circles/[id]/admin etc.),
// which has no hub view and lands on its first section.
export const Route = createFileRoute('/_authed/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/members' });
  },
});
